import PropTypes from 'prop-types'
import React from 'react';
import ColorBar from  './ColorBar'
import styles from './Splash.module.scss'


function Splash({mainMessage = 'Orbits Intectaction, click START to Continue',
                    headerCaption = 'Nova',
                    subHeaderCaption=  'SPACE',
                    callToActionCaption = 'START',
                    onStartClick =  () => {}}) {

    return <div className={styles.Splash}>
                <div className={styles.Container}>
                        <div className={styles.LeftContainer}>
                            <div className={styles.Captions}>
                                <div className={styles.HeaderCaption}>{headerCaption || 'Nova'}</div>
                                <div className={styles.SubHeaderCaption}>{subHeaderCaption || 'SPACE'}</div>
                            </div>

                            <div className={styles.ColorBar} >
                                <ColorBar />
                            </div>
                            <div className={styles.MainMessage} >
                                {mainMessage || 'Orbits, we are learning and making some smart choices about Orbits '}
                            </div>
                            <div className={styles.StartButton} onClick={onStartClick}>
                                {callToActionCaption}
                            </div>
                        </div>
                        <div className={styles.RightContainer}>
                            <div className={styles.Satellite }>
                                <img src={'https://clients.alleni.com/app/webroot/client_projects/NOVA/Nova-Space/Mod01/img/sattelite_orbits_splash.png'} />
                            </div>
                        </div>
                </div>
    </div>

}

export default Splash;

Splash.propTypes = {
  headerCaption: PropTypes.string,
  mainMessage: PropTypes.string,
  onStartClick: PropTypes.any,
  subHeaderCaption: PropTypes.string
}

Splash.defaultProps = {
  headerCaption: 'Nova',
  mainMessage: 'Orbits Interaction, click START to Continue',
  onStartClick: () => {},
  subHeaderCaption: 'SPACE'
}
